import { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Spin } from 'antd';
import plan from '../../data/plan';
import tutor from '../../data/tutor';
import dbMgr from '../../modules/dbManager';
import { videoPreLoader } from '../../modules/preload';
import { USER_POINTS_TO_ASK_REVIEW, USES_MULT_TO_ASK_REVIEW, USES_TO_ASK_REVIEW } from '../../modules/review';
import { generateReinforcementExercises, getNewTutorMessage, getStrengthenExercises, reviewTutor, saveUserStrengthen, showTutor } from '../../modules/tutor';
import { ACTIVATE_TUTOR, RATE_STATE, updateUserFields } from '../../modules/user';
import { getPlainVideos, getSubsetVideos } from '../../utils';
import DailyGoal from '../DailyGoal';
import RequestReview from '../RequestReview';
import Tutor from './Tutor';

const TutorManager = ({ user, lang, userIsLoading, responseIsFetching, today_time, daily_goal_reached, results, section, updateUserFields, exercise_opened, saveUserStrengthen, showTutor, shown_tutor, asked_review, reviewTutor, reviewed_tutor }) => {

    const [executionMessages, setExecutionMessages] = useState([]);
    const [tutorMessage, setTutorMessage] = useState(null);
    const [preloading, setPreloading] = useState(true);
    const [preloadReady, setPreloadReady] = useState((!ACTIVATE_TUTOR || !user.tutor) || false);
    const [age, setAge] = useState(1);


    const _mustShowReview = () => {
        if (!exercise_opened) {
            const uses = user.uses || 0;
            const rateState = user.rateState || 0;
            // const ask = !asked_review && (uses > 0 && (uses % 5 === 0 || uses === USES_TO_ASK_REVIEW) || user.points >= USER_POINTS_TO_ASK_REVIEW) && (rateState === null || rateState === RATE_STATE.NONE || rateState === RATE_STATE.LATER);
            const ask = !asked_review &&
                (uses > 0 && (uses % USES_MULT_TO_ASK_REVIEW === 0 || uses === USES_TO_ASK_REVIEW) || user.points >= USER_POINTS_TO_ASK_REVIEW) &&
                (rateState === null || rateState === RATE_STATE.NONE);
                
            // console.log('TutorManager._mustShowReview:', uses, rateState, user.points, '::', ask);
            return ask;
        }
        return false;
    }

    const _mustShowTutor = () => {
        if (!(ACTIVATE_TUTOR && user.tutor)) return false;

        const lastTutorMess = user.lastTutorMess;
        const last = results.last;

        if (user.dailyGoal && !exercise_opened) {
            const currentAgeVideos = getPlainVideos(tutor[age]);
            const last_uid_n = last ? (`${last.uid}_${last.n}`) : '';
            const newTutorMessage = getNewTutorMessage(last, lastTutorMess, currentAgeVideos, results, today_time);
            // console.log('!!!TutorManager._mustShowTutor: newTutorMessage:', newTutorMessage, ':: shown:', shown_tutor, last_uid_n);
            if (newTutorMessage && shown_tutor !== last_uid_n) {
                setTutorMessage([newTutorMessage]);
                if (newTutorMessage.indexOf('wel') < 0) showTutor(last_uid_n);
                return true;
            }
        }

        /* Force Koyu appearance */
        // setTutorMessage([lastTutorMess]);
        // return true;

        return false;
    }

    useEffect(() => {
        if (user) {
            // console.log('TutorManager.useEffect[] ...', user);
            setAge(user.age || 1);
        }
    }, []);

    useEffect(() => {
        if (user) {
            // console.log('TutorManager.useEffect[user] ...');
            _evalWhatToShow();
        }
    }, [user]);

    useEffect(() => {
        // console.log('TutorManager.useEffect[exercise_opened] ...');
        _evalWhatToShow();
    }, [exercise_opened]);

    useEffect(() => {
        if (results) {
            // console.log('TutorManager.useEffect[results] ...', results, responseIsFetching);
            _evalWhatToShow();
            _evalWhatToPreload();
        }
    }, [results]);

    const _evalWhatToShow = () => {
        if (!exercise_opened && results && section === 'learn') {
            const _executionMessages = [];
            if (_mustShowTutor()) _executionMessages.push('tutor');
            if (_mustShowReview()) _executionMessages.push('requestReview');
            _executionMessages.push('dailyGoal');
            setExecutionMessages(_executionMessages);
        } else {
            // console.log('TutorManager.useEffect[results]: no results or !learn ...');
        }
    }

    const _evalWhatToPreload = () => {

        if (ACTIVATE_TUTOR && user.tutor && !preloadReady && results && section === 'learn') {
            const currentAgeVideos = tutor[age];
            const currentLevel = results.current_level;
            // console.log('TutorManager._evalWhatToPreload currentLevel:', currentLevel);

            dbMgr.isReady().then((ready) => {
                const videoSrcs = getSubsetVideos(currentAgeVideos, 0, currentLevel + 2, lang);
                videoPreLoader(videoSrcs, age, _onFinishPreloadHandle, lang).preload();
            }).catch(err => {
                console.log('TutorManager._evalWhatToPreload db error:', err);
            });
        } else {
            setPreloading(false);
        }
    }

    const _onFinishPreloadHandle = (response) => {
        // console.log('TutorManager._onFinishPreloadHandle preload finished:', response);
        setPreloadReady(true);
    }

    const handleCloseMessage = (who, target) => {
        // console.log('TutorManager handleCloseMessage:', who, target);
        if (who === 'tutor' && target && target.length > 0) {
            const lm = target.pop();
            updateUserFields({ lastTutorMess: lm });
            if (lm.indexOf('nok') >= 0) {
                // console.log('TutorManager handleCloseMessage modalContent:', modalContent);
                const last = results.last;
                const last_uid = last ? ('' + last.uid) : '';
                const test_result = { ...results[last_uid] };
                const agePlan = plan[age];
                const currentLevel = results.current_level;

                const uniqueExToImprove = getStrengthenExercises(test_result);
                const toImproveExers = generateReinforcementExercises(agePlan, currentLevel, uniqueExToImprove);
                saveUserStrengthen(currentLevel, toImproveExers);
            }
        }

        if (executionMessages && executionMessages.length) {
            const _executionMessages = [...executionMessages];
            _executionMessages.shift();
            setExecutionMessages(_executionMessages);
        }
    }

    // console.log('TutorManager executionMessages:', preloading, preloadReady, '::', executionMessages);

    const currentMessage = executionMessages[0];
    const hasTutor = preloadReady && executionMessages.includes('tutor'); //currentMessage === 'tutor';
    const hasDaily = preloadReady && executionMessages.includes('dailyGoal');// currentMessage === 'dailyGoal';
    const hasRequestReview = preloadReady && executionMessages.includes('requestReview');//currentMessage === 'requestReview';

    return <>
        {preloading && !preloadReady ? <Spin size="large" className="spinner" /> : null}
        {hasDaily && !hasTutor ? <DailyGoal handleCloseManager={handleCloseMessage} handleCloseManager={handleCloseMessage} /> : null}
        {hasRequestReview && !hasTutor ? <RequestReview handleCloseManager={handleCloseMessage} /> : null}
        {hasTutor ? <Tutor lang={lang} age={age} themes={tutorMessage} handleCloseManager={handleCloseMessage} user={user} shown_tutor={shown_tutor} reviewTutor={reviewTutor} reviewed_tutor={reviewed_tutor} updateUserFields={updateUserFields} /> : null}
    </>;
}


const mapStateToProps = ({ user, response, tutor }) => ({
    user: user.user,
    lang: user.lang,
    today_time: user.today_time,
    daily_goal_reached: user.daily_goal_reached,
    exercise_opened: user.exercise_opened,
    results: response.data,
    userIsLoading: user.isLoading,
    responseIsFetching: response.isFetching,
    shown_tutor: tutor.shown_tutor,
    reviewed_tutor: tutor.reviewed_tutor,
    asked_review: user.asked_review,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateUserFields,
            saveUserStrengthen,
            showTutor,
            reviewTutor
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TutorManager);
